import { modal } from "@mc/mc-legacy";
import SignRequestInternalApi from "../api/gen/qsign/SignRequestInternalApi";
import PodepisovaniPdfViewer from "../components/PodepisovaniPdfViewer";
export const showDocuments = (
  signRequest,
  selectUnsigned = false,
  type = null,
  onClose = null,
  viewMode,
  screenWidth,
  approval,
  reedOnly
) => {
  return (dispatch) => {
    SignRequestInternalApi.getPdfView(signRequest.id, type, selectUnsigned, approval).then((data) => {
      showPdfViewer(dispatch, signRequest, data, onClose, viewMode, screenWidth, reedOnly);
    });
  };
};
export const showDocument = (signRequestDocument, onClose = null, viewMode, screenWidth) => {
  return (dispatch) => {
    SignRequestInternalApi.getPdfViewDocument(signRequestDocument.id).then((data) => {
      showPdfViewer(dispatch, null, data, false, viewMode, screenWidth);
    });
  };
};

const showPdfViewer = (
  dispatch,
  signRequest,
  data,
  onClose = null,
  viewMode = PodepisovaniPdfViewer.VIEW_MODE.BASE,
  screenWidth,
  reedOnly
) => {
  dispatch(
    modal.ModalActions.show(
      PodepisovaniPdfViewer,
      {
        viewId: data.viewId,
        selectDocument: data.selectedView,
        showClose: true,
        signRequest: signRequest,
        closeIcon: "times",
        viewMode: viewMode,
        screenWidth: screenWidth,
        stampSize: {
          width: data.stampWidth,
          height: data.stampHeight,
        },
        reedOnly: reedOnly,
        onClose: () => {
          dispatch(modal.ModalActions.hide());
          onClose && onClose();
        },
      },
      null,
      {
        size: "fullscreen",
        noHeader: true,
        transparent: true,
        keyboard: false,
      }
    )
  );
};
